var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo } from 'react';
import { MainLayout } from '../../components/layouts/MainLayout';
import { Container, Row, Col } from '../../uikit/grid';
import { initialDataSlice } from '../../store/initialData/initialData.slice';
import { connect } from 'react-redux';
import { useScript } from '../../hooks/useScript.hook';
import { GAService } from '../../services/GAService';
import { useGAEventMeta } from '../../hooks/useGAEventMeta.hook';
import { useAudienceMarker } from '../../hooks/useAudienceMarker.hook';
import Box from '@mui/material/Box';
var IFRAME_SRC = 'https://partner.baufi24.de/scriptport/iframe.min.jsx?cat=affiliate&tool=mgtlead&type=assist&api=19f7114a7d905819ebc34d8f3426c7c2b686de145ce3143c5c5e75b72b0d1ccafad672b784e74eed12b755960b3daa99e0ed6042cc8458edf8e58ab08e1ce407&profil=1&css=smava';
var SCRIPT_ID = 'bf24aff_mgtlead';
var PARTNER_ID = '200059';
var mapStateToProps = function (state) { return ({
    initialLoanAmount: initialDataSlice.selectors.getAmount(state),
    placementId: initialDataSlice.selectors.getPlacementId(state),
}); };
export var RawBaufi24Page = function (_a) {
    var initialLoanAmount = _a.initialLoanAmount, placementId = _a.placementId;
    var audienceMarker = useAudienceMarker();
    var gaEventMeta = useGAEventMeta();
    var handlePostMessage = useCallback(function (_a) {
        var data = _a.data;
        var msg;
        try {
            if (typeof data === 'object') {
                // to skip messages from their "react-" tools
                msg = undefined;
            }
            // to cover prepared for API communication data only
            msg = JSON.parse(data);
        }
        catch (e) {
        }
        finally {
            if (!!msg && msg.event === 'lead') {
                GAService.onLeadCreated(placementId, gaEventMeta);
            }
        }
    }, [placementId, gaEventMeta]);
    useEffect(function () {
        window.addEventListener('message', handlePostMessage);
        return function onUnmount() {
            window.removeEventListener('message', handlePostMessage);
        };
    }, []);
    var prescisedSrc = useMemo(function () {
        var _a, _b;
        var queryParams = new URLSearchParams(__assign(__assign({ adChannel: PARTNER_ID }, (typeof initialLoanAmount === 'number' && (_a = {
                ventureReason: 'KaufBest',
                priceBuilding: String(initialLoanAmount)
            },
            _a['skip_lcs'] = 'true',
            _a))), (audienceMarker && (_b = {}, _b['sub-id'] = audienceMarker, _b))));
        return "".concat(IFRAME_SRC, "&").concat(queryParams.toString());
    }, [initialLoanAmount, audienceMarker]);
    // @note: useScript + div.id = SCRIPT_ID is a workaround,
    //  since partner required inserting of script right into JSX,
    //  that is not a React-way, according to that explanation:
    // https://stackoverflow.com/a/64815699
    useScript(prescisedSrc, {
        id: SCRIPT_ID,
    });
    return (React.createElement(MainLayout, null,
        React.createElement(Container, { disableGutters: function (theme) { return theme.breakpoints.down('md'); } },
            React.createElement(Box, { pr: 1, pl: 1 },
                React.createElement(Row, null,
                    React.createElement(Col, null,
                        React.createElement("div", { id: SCRIPT_ID })))))));
};
export var Baufi24Page = connect(mapStateToProps)(RawBaufi24Page);
